import { Component, Input, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { VillageState } from 'src/app/state/village.state';

@Component({
  selector: 'app-members-label',
  template: `<span *ngIf="membersLabel$ | async as label">{{
    showTitlecase ? (label | titlecase) : label
  }}<span *ngIf="plural">s</span></span>`,
})
export class MembersLabelComponent implements OnInit {
  @Select(VillageState.membersLabel) membersLabel$: Observable<string>;

  @Input() showTitlecase = false;
  @Input() plural = false;
  constructor() {}

  ngOnInit() {}
}
